import * as assets from "./madnesAssetsAdapter";
import { getAudioTracks } from "../../framework/src/engine/madnes/MadnesAudio"
import * as madnes from "../../framework/src/engine/madnes/madnes";
import * as MV from "../../framework/src/engine/madnes/madnes_variables";
import {to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";
import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {he} from "../../framework/src/engine/madnes/madnes_variables";
import {
    set_madnes_coins_shift,
    set_show_money_pos_x,
    set_show_money_pos_y
} from "../../framework/src/engine/madnes/madnes_anims";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {
    openinfo,
    t27_infomenu_close,
    t27_infomenu_init,
    t27_infomenu_left,
    t27_infomenu_open,
    t27_infomenu_right,
    t27_infomenu_update,
} from "../turbo27_infomenu";
import {wi} from "../../framework/src/engine/madnes/madnes_variables";
import {t27_rotate_run} from "../turbo27_core";
import {t27_print_desk} from "../turbo27_reels";
import {t27_print_reels} from "../turbo27_core_printer";
import {set_round_running} from "../../framework/src/engine/madnes/madnes_variables";


export const infotexts_languages = [
    "cs", "en", "fr", "hr", "ro", "pl", "de", "fi", "no", "ru", "es", "sr", "sv", "tr", "nl", "it"
];

export var cylinder_pos_top = 155;
export var cylinder_pos = new Array();
cylinder_pos[0] = 220;
cylinder_pos[1] = 520;
cylinder_pos[2] = 820;
//cylinder_pos[3] = 750;

// Animace jednotlivych symbolu + pozice ve sprite
export var icons = {};

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;


export function initGame(gameset) {

    set_madnes_coins_shift(-80);

    set_show_money_pos_x(wi / 2);
    set_show_money_pos_y(he / 2 + 55);


    // MV.set_config_load_symbols(false);

    madnes.set_ico_size(235, 160 + 6);

    // madnes_show_money_anim_callback_timeout = 40;

    madnes_set_sprite("coins", 152, 152);

    madnes_set_sprite('_sprite', 235, 160);
    madnes_set_sprite('_blur', 235, 160);

    madnes_set_sprite('font_menu_Big', 40, 40);
    madnes_set_sprite('font_big-win', 134, 159);
    madnes_set_sprite('icon_Fire_Q', 200, 200);
    madnes_set_sprite('fire_question', 53, 70);
    madnes_set_sprite('icon_Win', 160, 160);

    madnes_set_sprite('bwanim', 730, 400);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced();
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            t27_infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function initLoad() {

}

export function game_start() {
    t27_rotate_run()
}

export function print_desk() {
    t27_print_desk()
}

export function print_reels() {
    t27_print_reels();
}

export function infomenu_init() {
    t27_infomenu_init();
}

export function infomenu_open() {
    t27_infomenu_open();
}

export function infomenu_close() {
    t27_infomenu_close();
}

export function is_info_open() {
    return openinfo;
}

export function infomenu_left() {

    if(!openinfo) return;

    t27_infomenu_left();
}

export function infomenu_right() {

    if(!openinfo) return;

    t27_infomenu_right();
}

export function end_round_no_autostart() {
}

export function freespins_end_round(eventName, {ended}) {}

export function end_round_recalced() {
    set_round_running(false);
}

export function get_preinfo() {}

export function preinfo_close() {}